import React, { Fragment } from 'react';
import {
    Header,
    Grid, Segment, Table, Button, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import TableRow from '../../../../Admin/CreateCourse/TableRow';
import moment from 'moment';
import ThreeColumnTableRow from "../../../../Admin/CreateCourse/ThreeColumnTableRow";


export default class PollInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            types: [],
            type: {
                name: null,
                id: null
            }

        };
        this.getPollById = this.getPollById.bind(this);
    }
    componentWillMount() {
        this.getPollById(JSON.parse(localStorage.getItem('poll')).pollId);
    }

    componentDidMount() {

    }

    // dodati edit inf u zavisnosti od edit iz locala


    getPollById(id) {
        axios.post(`/questionnaire/${id}/`)// promijeniti rutu
            .then(res => {
                const poll = res.data;
                this.setState({
                    optLock: poll.optLock,
                    id: poll.id,
                    name: poll.name,
                    startDate: new Date(poll.activationDate),
                    endDate: new Date(poll.endDate),
                    resultDate: new Date(poll.statisticsActivationDate),
                    type: {
                        id: poll.questionnaireType.id,
                        name: poll.questionnaireType.name
                    },
                    comment: poll.comment
                });
            })
            .catch(err => {
                console.log('Failed to fetch poll data.');
            });
    }


    render() {
        let {
            name, startDate, endDate, resultDate, type, comment, types
        } = this.state;
        return (
            <Fragment>
                <Table celled unstackable compact>
                    { this.state.infoLoader ?
                        <Loader active inline="centered" /> :
                        <Table.Body>
                            <ThreeColumnTableRow
                                name="Naziv"
                                value={this.state.name}
                            />

                            <ThreeColumnTableRow
                                name="Datum objave"
                                value={moment(this.state.startDate).format('D. M. YYYY.')}
                            />
                            <ThreeColumnTableRow
                                name="Datum isteka"
                                value={moment(this.state.endDate).format('D. M. YYYY.')}
                            />
                            <ThreeColumnTableRow
                                name="Datum objave rezultata"
                                value={moment(this.state.resultDate).format('D. M. YYYY.')}
                            />

                            <ThreeColumnTableRow
                                name="Napomena"
                                value={this.state.comment || '/'}
                            />
                        </Table.Body>
                    }
                </Table>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollPreviewTabs/PollInfo/PollInfo.js